import { MEGABYTE } from '../../../../constants';
import { IMAGE_DIALOG_TYPES } from '../constants';

export const MAX_MEGABYTES_FILE_SIZE = 10;
export const MAX_FILE_SIZE = MEGABYTE * MAX_MEGABYTES_FILE_SIZE;

export const VALIDATION_ERROR_TYPES = {
  FILE_TYPE: 'type',
  FILE_SIZE: 'size',
};

export const VALIDATION_ERROR_MESSAGES = {
  [IMAGE_DIALOG_TYPES.LOGO]: {
    [VALIDATION_ERROR_TYPES.FILE_TYPE]:
      'Invalid file format. Logos must be formatted as gif, jpg, png or svg',
    [VALIDATION_ERROR_TYPES.FILE_SIZE]: `Invalid file size. Logos must be ${MAX_MEGABYTES_FILE_SIZE}mb or less in size`,
  },
  [IMAGE_DIALOG_TYPES.PHOTOS]: {
    [VALIDATION_ERROR_TYPES.FILE_TYPE]:
      'Invalid file format. Photos must be formatted as gif, jpg, png or svg',
    [VALIDATION_ERROR_TYPES.FILE_SIZE]: `Invalid file size. Photos must be ${MAX_MEGABYTES_FILE_SIZE}mb or less in size`,
  },
};

export const DRAG_OVER_ACTIVE_CLASS = 'drop-target-drag-over-active';
